__turbopack_context__.v({
  "active": "g1FfYq_active",
  "carousel": "g1FfYq_carousel",
  "center": "g1FfYq_center",
  "control": "g1FfYq_control",
  "desktopOnly": "g1FfYq_desktopOnly",
  "imageLoading": "g1FfYq_imageLoading",
  "indicator": "g1FfYq_indicator",
  "indicators": "g1FfYq_indicators",
  "info": "g1FfYq_info",
  "loader": "g1FfYq_loader",
  "mobileOnly": "g1FfYq_mobileOnly",
  "next": "g1FfYq_next",
  "prev": "g1FfYq_prev",
  "root": "g1FfYq_root",
  "scrollViewport": "g1FfYq_scrollViewport",
  "sidebar": "g1FfYq_sidebar",
});
